import React from 'react';
import { Dialog, DialogContent, Typography, Button } from '@mui/material';

interface MessageModalProps {
  open: boolean;
  onClose: () => void;
  message: string | null;
  buttonText: string;
}

const MessageModal: React.FC<MessageModalProps> = ({ open, onClose, message, buttonText }) => {

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        style: {
          borderRadius: 5,
          minWidth: '400px'
        }
      }}
    >
      <DialogContent>
        <Typography
          style={{
            color: '#1A1A1A',
            fontSize: 16,
            fontFamily: 'Helvetica Neue LT Std',
            fontWeight: 300,
            textAlign: 'center',
            marginBottom: '20px'
          }}
        >
          {message}
        </Typography>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
          <Button variant="contained" onClick={onClose}>
            {buttonText}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default MessageModal;
